export default __webpack_public_path__ + "static/media/note-white.48c3dd4f.svg";